import axios from "axios";

// Base configuration
const api = axios.create({
  baseURL: "https://api.uchselfservice.net/api",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    "Accept":"*/*"
  },
});

const publicapi = axios.create({
  baseURL: "https://api.uchselfservice.net/api",
  headers: {
    "Content-Type": "application/json",
    "Accept":"*/*"
  },
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// === AUTH SERVICES ===
export const login = async (email, password) => {
  const response = await publicapi.post("/auth/login/", { username_or_email:email, password });
  return response.data;
};

export const register = async (data) => {
  const response = await publicapi.post("/auth/register/", data);
  return response.data;
};

export const forgotPassword = async (email) => {
  const response = await publicapi.post("/auth/forgot-password/", { email });
  return response.data;
};

export const sendVerificationCode = async (data) => {
  const response = await publicapi.post("/verify-email/", data);
  return response.data;
};

export const ResendVerificationCode = async (data) => {
  const response = await publicapi.post("/resend-verification-code/", data);
  return response.data;
};

export const getUser = async () => {
  const res = await api.get("/auth/profile/");
  return res.data;
};

export const PaymentMethods = async (data) => {
  const res = await publicapi.get("/express/methods/");
  return res.data;
};

export const PaymentCheckout = async (data) => {
  const res = await publicapi.post("/express/checkout/", data);
  return res.data;
};

export const PaymentWalletCheckout = async (data) => {
  const res = await api.post("/express/checkout/", data);
  return res.data;
};

export const Topup = async (data) => {
  const res = await api.post("/express/top-up/", data);
  return res.data;
};

export const updateAccount = async (data) => {
  const res = await api.post("/auth/profile/update/", data);
  return res.data;
};

export const updatePassword = async (data) => {
  const res = await api.post("/auth/profile/change-password/", data);
  return res.data;
};

export const upgradeToCorporate = async (data) => {
  const res = await api.post("/auth/kyc/upgrade/", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
}

export const updateKyc = async (data) => {
  const res = await api.put("/auth/kyc/update/", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const submitKyc = async (data) => {
  const res = await api.post("/auth/kyc/submit/", data);
  return res.data;
};

export const fetchKyc = async (data) => {
  const res = await api.get("/auth/kyc/me/", data);
  return res.data;
};

export const Withdraw = async (data) => {
  const res = await api.post("/auth/withdraw/", data);
  return res.data;
};

export const MyRefunds = async () => {
  const res = await api.get("/auth/my-refunds/");
  return res.data;
};

export const Statistics = async (data) => {
  const res = await api.post("/auth/admin/statistics/", data);
  return res.data;
};

export const AdminInvoice = async (data) => {
  const res = await api.post("/auth/admin/invoices/", data);
  return res.data;
};

export const MyInvoices = async () => {
  const res = await api.get("/invoices/");
  return res.data?.results || res.data;
};

export const AdminUserTransactions = async (userId, params = {}) => {
  const res = await api.get(`/auth/admin/transactions/user/${userId}/`, { params });
  return res.data;
};

export const AdminUserInvoices = async (userId) => {
  const res = await api.get(`/invoices/invoices/user/${userId}/`);
  return res.data;
};

export const AdminUpdateWalletStatus = async (id, data) => {
  const res = await api.patch(`/auth/admin/transactions/${id}/status/`, data);
  return res.data;
};

export const AdminTransaction = async (params = {}) => {
  const res = await api.post("/auth/admin/transactions/", {}, { params });
  return res.data;
};

export const AdminInvoiceStats = async (params = {}) => {
  const res = await api.get("/invoices/invoices/filter/", { params });
  return res.data;
};

export const AdminReport = async (data) => {
  const res = await api.get("/invoices/invoices/statistics/");
  return res.data;
};

export const AdminUpdateInvoice = async (id, data) => {
  const res = await api.patch(`/invoices/admin/invoices/${id}/status/`, data);
  return res.data;
};

export const AdminUpdateProfile = async (data) => {
  const res = await api.patch(`/auth/update/profile/`, data);
  return res.data;
};

export const RequestRefund = async (data) => {
  const res = await api.post("/auth/request-refund/", data);
  return res.data;
};

// === NEW ADMIN USER MANAGEMENT SERVICES ===

export const fetchUsers = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const res = await api.get(`/auth/users/hospital-users/?${query}`);
  return res.data;
};

export const fetchUserById = async (id) => {
  const res = await api.get(`/auth/users/single-user/${id}`);
  return res.data.user;
};


export const addUser = async (userData) => {
  const res = await api.post("/auth/users/create/", userData);
  return res.data;
};

export const AdminUpdateSettings = async (payload) => {
  const res = await api.patch("/auth/admin/update-profile/", payload);
  return res.data;
};

export const FetchSettings = async () => {
  const res = await api.get("/auth/admin/security-profile/");
  return res.data;
};

export const FetchLogs = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const res = await api.get(`/auth/admin/login-activity/${query ? `?${query}` : ""}`);
  return res.data;
};

export const AdminUpdateLog = async (payload) => {
  const res = await api.patch("/auth/admin/login-activity/update/", payload);
  return res.data;
};


export const updateUser = async (userId, updates) => {
  const res = await api.patch(`/auth/users/${userId}/`, updates);
  return res.data;
};


export const bulkDeleteUser = async (userIds) => {
  const res = await api.delete("/auth/users/bulk-delete/", {
    data: { ids: userIds },
  });
  return res.data;
};


export const deactivateUser = async (userId) => {
  const res = await api.patch(`/auth/users/${userId}/status/`, { status: "inactive" });
  return res.data;
};


export const activateUser = async (userId) => {
  const res = await api.patch(`/auth/users/${userId}/status/`, { status: "active" });
  return res.data;
};

export const getAllSupportTickets = async () => {
  const res = await api.get("/auth/support/tickets");
  return res.data.results || res.data;
};

// Site settings
export const getSiteSettings = async () => {
  const res = await api.get("/auth/settings/");
  return res.data;
};

export const updateSiteSettings = async (data) => {
  const res = await api.patch("/auth/settings/", data);
  return res.data;
};

export const getGatewaySettings = async (gateway) => {
  const res = await api.get(`/settings/${gateway}/`);
  return res.data;
};

export const requestGatewayChangeCode = async (gateway, values) => {
  const res = await api.post(`/settings/${gateway}/request-code/`, { values });
  return res.data;
};

export const confirmGatewayChange = async (gateway, payload) => {
  const res = await api.post(`/settings/${gateway}/confirm/`, payload);
  return res.data;
};

export const getMonnifyPublicConfig = async () => {
  const res = await publicapi.get("/settings/monnify/public/");
  return res.data;
};

export const getRemitaPublicConfig = async () => {
  const res = await publicapi.get("/settings/remita/public/");
  return res.data;
};

// Refund management
export const getAllRefunds = async () => {
  const res = await api.get("/auth/refunds/");
  return res.data;
};

export const refundAction = async (reference, action, reason = "") => {
  const res = await api.patch(`/auth/refunds/${reference}/action/`, { action, reason });
  return res.data;
};

export const getSupportTicketById = async (id) => {
  const res = await api.get(`/auth/support/tickets/${id}`);
  return res.data;
};

export const replyToSupportTicket = async (ticketId, { message }) => {
  const res = await api.post(`/auth/support/tickets/${ticketId}/reply`, { message });
  return res.data;
};

export const updateSupportTicketStatus = async (ticketId, { status }) => {
  const res = await api.patch(`/auth/support/tickets/${ticketId}`, { status });
  return res.data;
};


export default api;
